<!--
@Time : 2020/11/26 1:41 下午
@Author : yekong
@File : paiming.vue
@Software : PhpStorm
-->
<template>
  <div>
    <div class="paiming">
      互联网+招标釆购
    </div>
    <div class="paiming2">
      <div class="ms">
        互联网+招标采购综合变了度评估结果显示,上海综合得分最高, 本市排名第2名,得分相差10
      </div>
      <div class="paiming2x">
        <hicschart id="high" class="high"></hicschart>
<!--        <div id="huodexindai3" :style="{width: '700px', height: '600px'}"></div>-->
      </div>
    </div>
  </div>
</template>

<script>
import hicschart from "@/components/hicschart";

export default {
  components: {hicschart},
  name: "paiming",
  data: function () {
    return {
      list: [{
        title: '上海',
        fenshu: 96
      }, {
        title: '大连',
        fenshu: 96
      }, {
        title: '北京',
        fenshu: 96
      }, {
        title: '深圳',
        fenshu: 96
      }]
    }
  },
  props: {
    top: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  created: function () {

  },
  filters: {},
  methods: {
    drawLine() {
      // 基于准备好的dom，初始化echarts实例
      let myChart = this.$echarts.init(document.getElementById('huodexindai3'))
      // 绘制图表
      myChart.setOption({
        grid: {
          top: '5%',
          right: '0%',
          left: '18%',
          bottom: '19%'
        },
        xAxis: [{
          type: 'category',
          color: '#59588D',
          data: ['北京', '上海', '深圳', '大连'],
          axisLabel: {
            margin: 20,
            color: 'rgba(236, 239, 249, 1)',
            textStyle: {
              fontSize: 30
            },
          },
          axisLine: {
            lineStyle: {
              color: 'rgba(255, 255, 255, 1)',
              width: 2
            }
          },
          axisTick: {
            show: false
          },
        }],
        yAxis: [{
          minInterval: 25,
          axisLabel: {
            formatter: '{value}分',
            color: 'rgba(155, 173, 255, 1)',
            textStyle: {
              fontSize: 30
            },
          },
          axisLine: {
            lineStyle: {
              color: 'rgba(255, 255, 255, 1)',
              width: 3
            }
          },
          axisTick: {
            show: false
          },
          splitLine: {
            lineStyle: {
              color: '#fff',
              type: 'dashed',
            }
          }
        }],
        series: [{
          type: 'bar',
          data: [90, 80, 20, 20],
          barWidth: '33px',
          itemStyle: {
            normal: {
              color: function (params) {
                var colorList = ['rgba(63, 190, 226, 1)', 'rgba(63, 190, 226, 1)', 'rgba(63, 190, 226, 1)', 'rgba(236, 141, 91, 1)'];
                return colorList[params.dataIndex];
              },
            },
          },
          label: {
            normal: {
              show: false,
              fontSize: 18,
              fontWeight: 'bold',
              color: '#333',
              position: 'top',
            }
          }
        }
        ]
      });
    }
  },
  mounted() {
    this.drawLine()
  },
}
</script>

<style lang="scss" scoped>
@import "../../main";

.paiming {
  height: 145px;
  @include flex_start_center();
  font-size: 60px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #FFFFFF;
  margin-top: 70px;
}

.paiming2 {
  height: 849px;
  background: url("../../assets/kuangjialeft.png") left top no-repeat,
  url("../../assets/kuangjiabottom.png") right bottom no-repeat,
  rgba(35, 77, 205, 0.16);
  padding-top: 40px;
}

.body {
  width: 855px;
  margin: auto;
}

.bodyitem {
  height: 84px;
  @include flex_between_center();
  border-bottom: 2px solid rgba(77, 90, 127, 1);
  box-sizing: border-box;

  .item1, .item2, .item3 {
    width: 30%;
    @include flex_center_center();
    font-size: 30px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #ECEFF9;
  }

  .item3 {
    width: 40%;
  }
}

.ms {
  width: 742px;
  height: 95px;
  font-size: 22px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #ECEFF9;
  line-height: 36px;
  margin: 0px auto 20px;
}

.chengben2 {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: nowrap;
  flex-direction: row;

  .chengben3 {
    margin-left: -60px;
  }
}

.paiming2x {
  @include flex_center_center();
}
</style>
